import React from 'react';

import '../../eingabe/Eingabe.css';
import EingabeKulissentyp from "../../eingabe/EingabeKulissentyp";
import EingabeKulissenbreite from "../../eingabe/EingabeKulissenbreite";
import AusgabeKulissenwerte from "../ausgabeKulissenwerte/AusgabeKulissenwerte";
import EingabeZusatzoptionen from "../../eingabe/EingabeZusatzoptionen";
import {FormattedMessage} from "react-intl";
import { parseKulissenConfig, serializeKulissenConfig, buildShareUrl } from "../../utils/eingabeUrlState";

class EingabeKulissenwerte extends React.Component {
       constructor(props) {
    super(props);
    // Eingabezustand aus der URL wiederherstellen (Issue #43); ungueltige/
    // fehlende Parameter fallen auf die bisherigen Defaults zurueck.
    const urlConfig = parseKulissenConfig(
        typeof window !== "undefined" && window.location ? window.location.search : ""
    );
    this.state = {
        kulissenlaenge: urlConfig.kulissenlaenge,
        kulissenhoehe: urlConfig.kulissenhoehe,
        selectedKulissenbreite: urlConfig.selectedKulissenbreite,
        selectedKulissentyp: urlConfig.selectedKulissentyp,
        optionen: [
            {id: 1, value:<FormattedMessage id="Kulissen_in_Folie" />, isChecked: urlConfig.optionenChecked[0]},
            {id: 2, value:<FormattedMessage id="Fuehrungsschienen_im_Kanal" />, isChecked: urlConfig.optionenChecked[1]},
            {id: 3, value:<FormattedMessage id="Anstroemkalotten_einseitig_V_Form" />, isChecked: urlConfig.optionenChecked[2]},
        ],

        rabatt: urlConfig.rabatt,
        linkKopiert: false,

        //kulissenanzahl : 1,
    };
    this.handleInputChange= this.handleInputChange.bind(this);
    this.getSelectedKulissentypHandler = this.getSelectedKulissentypHandler.bind(this);
    this.getSelectedKulissenbreiteHandler = this.getSelectedKulissenbreiteHandler.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.copyShareLink = this.copyShareLink.bind(this);
  }

  componentDidUpdate() {
      this.syncUrl();
  }

  // Aktuelle Kulissen-Eingabe (nur technische Parameter) fuer URL/Link.
  currentConfig() {
      return {
          kulissenhoehe: this.state.kulissenhoehe,
          kulissenlaenge: this.state.kulissenlaenge,
          selectedKulissenbreite: this.state.selectedKulissenbreite,
          selectedKulissentyp: this.state.selectedKulissentyp,
          rabatt: this.state.rabatt,
          optionenChecked: this.state.optionen.map((option) => option.isChecked),
      };
  }

  syncUrl() {
      if (typeof window === "undefined" || !window.history || !window.location) {
          return;
      }
      const query = serializeKulissenConfig(this.currentConfig());
      const newUrl = `${window.location.pathname}?${query}`;
      if (`${window.location.pathname}${window.location.search}` !== newUrl) {
          window.history.replaceState(null, "", newUrl);
      }
  }

  async copyShareLink() {
      const query = serializeKulissenConfig(this.currentConfig());
      const url = buildShareUrl(query);
      try {
          if (navigator.clipboard && navigator.clipboard.writeText) {
              await navigator.clipboard.writeText(url);
          } else {
              const textarea = document.createElement("textarea");
              textarea.value = url;
              textarea.setAttribute("readonly", "");
              textarea.style.position = "absolute";
              textarea.style.left = "-9999px";
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand("copy");
              document.body.removeChild(textarea);
          }
          this.setState({ linkKopiert: true });
          window.setTimeout(() => this.setState({ linkKopiert: false }), 2000);
      } catch (error) {
          // Kein Absturz, falls die Zwischenablage nicht verfuegbar ist.
      }
  }

  getSelectedKulissenbreiteHandler(data) {

       this.setState((state) => {
           return {selectedKulissenbreite: data}
       });
  }

  getSelectedKulissentypHandler(data) {

       this.setState((state) => {
           return {selectedKulissentyp: data}
       });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.name === 'isGoing' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value    });
  }
  onKeyUp(event) {
      if (event.key === "Enter") {
          this.handleInputChange(event);
      }
  }

  // handleCheckChieldElement = (event) => {
  //       let optionen = this.state.optionen;
  //       console.log("Option ID Change: " + event.target.value);
  //         // Wenn Kulissen in Folie nur HKL Kulissen
  //         if(event.target.value == "Kulissen in Folie"){
  //             console.log("Option ID Change: " + event.target.value);
  //             this.getSelectedKulissentypHandler('HKL');
  //         }
  //       optionen.forEach(optionen => {
  //           if (optionen.id == event.target.id) {
  //               optionen.isChecked = event.target.checked;
  //           }
  //       })
  //       this.setState({optionen: optionen})
  // }
  handleCheckChieldElement = (event) => {
        let optionen = this.state.optionen
        // console.log("Option ID Change: " + event.target.value);
        // console.log("Option ID Change: " + event.target.id);
        // if(event.target.value == "Kulissen in Folie"){
        //     console.log("Option ID Change: " + event.target.value);
        //     this.getSelectedKulissentypHandler('HKL');
        // }
        // Kulissen in Folie = HKL
        if(Number(event.target.id) === 1){
            // console.log("Option ID Change: " + event.target.value);
            this.getSelectedKulissentypHandler('HKL');
        }
        // optionen[0].isChecked = event.target.checked;

        optionen.forEach(option => {
            // console.log("Optionen: " + option.id+ " " + event.target.id);
            // console.log("Optionen-target-id: "+ event.target.id);
            if (option.id === Number(event.target.id)) {
                // console.log("Optionen: " + event.target.value + " geändert");
                option.isChecked = event.target.checked;
            }
        })
        this.setState({optionen: optionen})
  }

  render() {
    return(
        <>
            <div className={"form-style-8"}>
                <h2><FormattedMessage id="Eingabe_Kulissen" /></h2>
                <form>
                    <EingabeKulissentyp value={this.state.selectedKulissentyp}  SelectedKulissentyp={this.getSelectedKulissentypHandler} disabledChecked={this.state.optionen[0].isChecked}/>
                    <EingabeKulissenbreite value={this.state.selectedKulissenbreite}  SelectedKulissenbreite={this.getSelectedKulissenbreiteHandler} defaultValue={100}/>
                    <div>
                          <label htmlFor="kulissenhoehe"><FormattedMessage id="Kulissenhoehe" />[mm]{this.state.kulissenlaenge > 4000 ? " max. 4000mm" : this.state.kulissenhoehe <200 ? " min. 200mm" : ""}</label>
                          <input type="number" id='kulissenhoehe' min="200" max="4000" name='kulissenhoehe' defaultValue={this.state.kulissenhoehe}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>

                    <div>
                          <label htmlFor="kulissenlaenge"><FormattedMessage id="Kulissenlaenge" /> [mm]{this.state.kulissenlaenge > 4000 ? " max. 4000mm" : this.state.kulissenlaenge <200 ? " min. 200mm" : ""}</label>
                          <input type="number" id='kulissenlaenge' min="200" max="4000" name='kulissenlaenge' defaultValue={this.state.kulissenlaenge}
                                 onBlur={this.handleInputChange}
                                 onKeyUp={this.onKeyUp}
                                 required/>
                    </div>
                        <label><FormattedMessage id="Zusatzoptionen" />: </label>
                        {
                            this.state.optionen.map((optionen) => {
                                return (<EingabeZusatzoptionen handleCheckChieldElement={this.handleCheckChieldElement} key={optionen.id}  id={optionen.id} checked={optionen.isChecked} value={optionen.value} />)
                            })
                        }


                    <div>
                        <label htmlFor="rabatt"><FormattedMessage id="Rabatt" /> [%]</label>
                        <input type="number" id='rabatt' min="0.0" max="100.0" name='rabatt' defaultValue={this.state.rabatt}
                               onBlur={this.handleInputChange}
                               onKeyUp={this.onKeyUp}
                               required/>
                    </div>
                </form>

            </div>
            <AusgabeKulissenwerte
                Kulissenbreite={this.state.selectedKulissenbreite}
                Kulissenlaenge={this.state.kulissenlaenge}
                Kulissenhoehe={this.state.kulissenhoehe}
                Kulissentyp={this.state.selectedKulissentyp}
                Rabatt={this.state.rabatt}
                Optionen={this.state.optionen}
                onCopyShareLink={this.copyShareLink}
                linkKopiert={this.state.linkKopiert}
            />
        </>
    )

  }
}
export default EingabeKulissenwerte;
